import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { routesData } from './routes';
import PrivateRoute from './PrivateRoute';
import NotFoundPage from '../components/NotFound/NotFoundPage';

class SubMenuRoute extends React.PureComponent {
  render() {
    const { path: matchPath } = this.props;
    const routes = routesData.find(route => route.path === matchPath).children;
    return (
      <Switch>
        {routes.map(({ exact, path, component }) => (
          <PrivateRoute
            exact={exact}
            key={path}
            path={path}
            component={component}
          />
        ))}
        <Route path="/" component={NotFoundPage} />
      </Switch>
    );
  }
}

export default SubMenuRoute;



// WEBPACK FOOTER //
// ./foody/src/routes/SubMenuRoute.jsx